import { QuestionTypeEnum } from './question-type-enum'

export interface QuestionInterface {
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
  /**
   * 父ID
   */
  parentId?: number
  /**
   * 题目类型
   */
  type: QuestionTypeEnum
  /**
   * 题干富文本
   */
  stem?: string | null
  /**
   * 选项
   */
  options?: string[]
  /**
   * 标准答案
   */
  standardAnswers?: string[]
  /**
   * 解析
   */
  analysis?: string | null
  /**
   * 难度等级(填写整数)
   */
  difficultyLevel?: number
  score?: string | null
  /**
   * 学科知识点 id数组
   */
  subjectKnowledgePoints?: number[]
  /**
   * 学科核心素养 id数组
   */
  subjectCoreLiteracys?: number[]
  /**
   * 学科能力 id 数组
   */
  subjectAbilities?: number[]
  /**
   * 标签 id 数组
   */
  tags?: number[]
  /**
   * 题目额外设置
   */
  settings?: object | null
  vid?: number
  isPublished?: boolean
  treeNodeId?: number
  treeNodePid?: number
  /**
   * 题目排序值
   */
  weight?: number
  /**
   * 关联的题库题目 id
   */
  bankQuestionId?: number
  /**
   * 学部ID
   */
  gradeGroupId?: number
}

export class Question implements QuestionInterface {
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
  /**
   * 父ID
   */
  parentId?: number
  /**
   * 题目类型
   */
  type: QuestionTypeEnum
  /**
   * 题干富文本
   */
  stem?: string | null
  /**
   * 选项
   */
  options?: string[]
  /**
   * 标准答案
   */
  standardAnswers?: string[]
  /**
   * 解析
   */
  analysis?: string | null
  /**
   * 难度等级(填写整数)
   */
  difficultyLevel?: number
  score?: string | null
  /**
   * 学科知识点 id数组
   */
  subjectKnowledgePoints?: number[]
  /**
   * 学科核心素养 id数组
   */
  subjectCoreLiteracys?: number[]
  /**
   * 学科能力 id 数组
   */
  subjectAbilities?: number[]
  /**
   * 标签 id 数组
   */
  tags?: number[]
  /**
   * 题目额外设置
   */
  settings?: object | null
  vid?: number
  isPublished?: boolean
  treeNodeId?: number
  treeNodePid?: number
  /**
   * 题目排序值
   */
  weight?: number
  /**
   * 关联的题库题目 id
   */
  bankQuestionId?: number
  /**
   * 学部ID
   */
  gradeGroupId?: number

  constructor(props: QuestionInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      id: _id,
      schoolId: _schoolId,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      parentId: _parentId,
      type: _type,
      stem: _stem,
      options: _options,
      standardAnswers: _standardAnswers,
      analysis: _analysis,
      difficultyLevel: _difficultyLevel,
      score: _score,
      subjectKnowledgePoints: _subjectKnowledgePoints,
      subjectCoreLiteracys: _subjectCoreLiteracys,
      subjectAbilities: _subjectAbilities,
      tags: _tags,
      settings: _settings,
      vid: _vid,
      isPublished: _isPublished,
      treeNodeId: _treeNodeId,
      treeNodePid: _treeNodePid,
      weight: _weight,
      bankQuestionId: _bankQuestionId,
      gradeGroupId: _gradeGroupId,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.id = _id
    this.schoolId = _schoolId
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
    this.parentId = _parentId
    this.type = _type
    this.stem = _stem
    this.options = _options
    this.standardAnswers = _standardAnswers
    this.analysis = _analysis
    this.difficultyLevel = _difficultyLevel
    this.score = _score
    this.subjectKnowledgePoints = _subjectKnowledgePoints
    this.subjectCoreLiteracys = _subjectCoreLiteracys
    this.subjectAbilities = _subjectAbilities
    this.tags = _tags
    this.settings = _settings
    this.vid = _vid
    this.isPublished = _isPublished
    this.treeNodeId = _treeNodeId
    this.treeNodePid = _treeNodePid
    this.weight = _weight
    this.bankQuestionId = _bankQuestionId
    this.gradeGroupId = _gradeGroupId
  }
}
